import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

export const EMeetingRecurringStatus = [
  { name: 'Does not repeat', code: 'none' },
  { name: 'Daily', code: 'DAILY' },
  { name: 'Weekly', code: 'WEEKLY' },
  { name: 'Monthly', code: 'MONTHLY' }
];

@Component({
  selector: 'app-custom-switch',
  template: `
    <div>
      <label>{{ props.label }}</label>
      <p-dropdown
        class="my-0"
        optionLabel="name"
        optionValue="code"
        [formControl]="$any(formControl)"
        [options]="status"
      />
    </div>
  `
})
export class CustomDropDownComponent extends FieldType {
  status = EMeetingRecurringStatus;
}
